export const EVENTS = 'fo/events/page'
export const EVENT = 'fo/events/edit'
export const ADD_EVENT = 'fo/events/add'
export const UPDATE_EVENT = 'fo/events/update'
export const DELETE_EVENT = 'fo/events/delete'
